import styled from 'styled-components'

export const StyledTotalPurchaseValue = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 0.5em;

  .title {
    display: flex;
    align-self: flex-start;
    gap: 6px;
    font-family: SUIT;
    font-size: 1rem;
    line-height: 20px;
    color: #333;
    font-weight: 700;
    margin-bottom: 1em;

    .vertical-line {
      display: inline-block;
      height: 20px;
      width: 4px;
      background-color: #2f3c5e;
      border-radius: 99px;
    }
  }

  .warning-message {
    align-self: flex-start;
    margin-top: -0.75em;
    margin-bottom: 0.5em;
    color: #d05b36;
    font-size: 0.75rem;
    font-weight: 600;
  }

  .add-row-wrapper {
    margin-bottom: 8px;
  }

  .total-section {
    display: flex;
    flex-direction: row;
    gap: 2em;
    border: 1px solid #c2ecdf;
    background-color: #f4fcfa;
    border-radius: 8px;
    width: 100%;
    padding: 14px 0;
    justify-content: center;

    .subtitle {
      color: #808080;
      font-size: 0.75rem;
    }

    .presentation-section {
      margin-top: 2px;
      text-align: center;
      color: #57c9a7;
    }

    .presentation-section span:first-child {
      font-size: 1.37em;
    }

    .presentation-section span:last-child {
      font-size: 1.12em;
    }
  }

  table {
    text-align: center;
    width: 100%;
    font-size: 0.75em;
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid #e6e6e6;
    border-radius: 8px;

    th {
      background-color: #f4f5f8;
      color: #333333;
    }

    th,
    td {
      padding: 12.8px 0;
      border-right: 1px solid #e6e6e6;
      border-bottom: 1px solid #e6e6e6;
    }

    th:last-child,
    td:last-child {
      border-right: none;
    }

    tr:last-child th,
    tr:last-child td {
      border-bottom: none;
    }

    th:first-child {
      border-top-left-radius: 8px;
    }

    th:last-child {
      border-top-right-radius: 8px;
      border-right: none;
    }

    tr:last-child td:first-child {
      border-bottom-left-radius: 8px;
    }

    tr:last-child td:last-child {
      border-bottom-right-radius: 8px;
      border-bottom: none;
    }

    select {
      border: none;
      width: 100%;
      color: #b3b3b3;
    }

    .delete-btn {
      width: 6%;
      border-radius: 0 !important;
      font-size: 0.75em;

      :nth-child(1) {
        cursor: pointer;
      }
    }
  }
`

export const PurchaseUnitComparisonTitle = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  margin-top: 10px;
  color: var(--bluegray50, #2f3c5e);
  font-family: SUIT;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  white-space: nowrap;

  &::before,
  &::after {
    content: '';
    height: 1px;
    flex: 1;
    background: var(--gray30, #e6e6e6);
  }
`
